// extracted by mini-css-extract-plugin
module.exports = {"days":"fM","additionalInfo":"fN","hidden":"fO","centerMenu":"fP","logo":"fQ","social":"fR","socialLink":"fS"};